import {useRequest} from "ahooks";
import {userHome, getDepositInitInfo} from "@/services/user";

const useUserVariteies = () => {
  const userHomeReq = useRequest(async () => {
    const res = await userHome()
    return res
  }, { manual: false })
  return userHomeReq
}

const useDepositInit = () => {
  const getDepositInitInfoReq = useRequest(async (varietyCode, coin?) => {
    let data: any = {
      varietyCode
    }
    if (coin) {
      data = {...data, coin}
    }
    const res = await getDepositInitInfo(data)
    return res
  }, { manual: true })
  return getDepositInitInfoReq

}

export {
  useUserVariteies,
  useDepositInit
}